import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  fetchDealerRemainsReports,
  fetchDealerSalesReports,
  generateRemainReport,
  generateSalesReport,
} from "../../api/thunks";
import {
  DealerSliceState,
  IDealerRemainsReport,
  IDealerSalesReport,
} from "../types";

export const addReportsExtraReducers = (
  builder: ActionReducerMapBuilder<DealerSliceState>,
) => {
  builder.addCase(fetchDealerRemainsReports.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(fetchDealerRemainsReports.fulfilled, (state, action) => {
    state.dealerRemainsReports = action.payload.reports;
    const manualReports = action.payload.reports?.filter(
      (r: IDealerRemainsReport) => r.isManual,
    );
    state.dealerRemainsLastManualReport =
      manualReports.length !== 0 ? manualReports[0].createdDate : null;
    state.error = null;
    state.isLoading = false;
  });
  builder.addCase(fetchDealerRemainsReports.rejected, (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  });

  builder.addCase(fetchDealerSalesReports.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(fetchDealerSalesReports.fulfilled, (state, action) => {
    state.dealerSalesReports = action.payload.reports;
    const manualReports = action.payload.reports?.filter(
      (r: IDealerSalesReport) => r.isManual,
    );
    state.dealerSalesLastManualReport =
      manualReports.length !== 0 ? manualReports[0].createdDate : null;
    state.error = null;
    state.isLoading = false;
  });
  builder.addCase(fetchDealerSalesReports.rejected, (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  });

  builder.addCase(generateRemainReport.pending, (state) => {
    state.error = null;
    state.isMiniLoading = true;
  });
  builder.addCase(generateRemainReport.fulfilled, (state, action) => {
    state.dealerRemainsReports = [
      ...action.payload.reports,
      ...state.dealerRemainsReports,
    ];
    state.dealerRemainsLastManualReport = action.payload.reports[0].createdDate;
    state.error = null;

    state.isMiniLoading = false;
  });
  builder.addCase(generateRemainReport.rejected, (state, action) => {
    state.error = action.payload;
    state.isMiniLoading = false;
  });

  builder.addCase(generateSalesReport.pending, (state) => {
    state.error = null;
    state.isMiniLoading = true;
  });
  builder.addCase(generateSalesReport.fulfilled, (state, action) => {
    state.dealerSalesReports = [
      ...action.payload.reports,
      ...state.dealerSalesReports,
    ];
    state.dealerSalesLastManualReport = action.payload.reports[0].createdDate;
    state.error = null;
    state.isMiniLoading = false;
  });
  builder.addCase(generateSalesReport.rejected, (state, action) => {
    state.error = action.payload;
    state.isMiniLoading = false;
  });
};
